export const mutations = {
    setGrupoPermissao(state, data) {
        state.grupoPermissao = data
    },
    setGruposPermissoes(state, data) {
        state.gruposPermissoes = data
    },
    addGrupoPermissao(state, data){
        state.gruposPermissoes.push(data)
    },
    removeGrupoPermissao(state, data){
        let index = state.gruposPermissoes.map(x => x.id).indexOf(data.id);
        state.gruposPermissoes.splice(index, 1)
    },
    setModalCadastrarGrupoPermissao(state, status) {
        state.modalCadastrarGrupoPermissao = status
    },
    setModalExcluirGrupoPermissao(state, status) {
        state.modalExcluirGrupoPermissao = status
    },
    setModalPesquisarGrupoPermissao(state, status) {
        state.modalPesquisarGrupoPermissao = status
    }
}

export default {}